export type FilterOption = { label: string; value: string };

export const toOptions = (values: string[] | undefined): FilterOption[] =>
  (values ?? []).map((value) => ({ value, label: value }));

const regionNames = (() => {
  try {
    return new Intl.DisplayNames(['en-GB'], { type: 'region' });
  } catch {
    return null;
  }
})();

/**
 * Countries are stored as ISO-2 codes, so the option reads "Germany (DE)":
 * typing either the name or the code finds it. A value that is not a code,
 * such as MENA, is shown as it is.
 */
export const toCountryOptions = (codes: string[] | undefined): FilterOption[] =>
  (codes ?? [])
    .map((code) => {
      let name: string | undefined;
      try {
        name = code.length === 2 ? regionNames?.of(code) : undefined;
      } catch {
        name = undefined;
      }
      return { value: code, label: name && name !== code ? `${name} (${code})` : code };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
